import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { buildQueryParams } from "@/shared/utils/utils";

export const ticketsApi = api
  .enhanceEndpoints({
    addTagTypes: ["ticket"],
  })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      getAllTickets: builder.query({
        query: (params) => ({
          //url: `get-all-tickets?branch_id=${branch_id}`,
          url: `get-all-tickets`,
          method: RequestMethod.GET,
          params: buildQueryParams(params),
        }),
        providesTags: (result) => (result ? [{ type: "ticket" }] : []),
      }),

      getSupportStaffTickets: builder.query({
        query: () => ({
          url: `/assigned/support-staff`,
          method: RequestMethod.GET,
        }),
      }),
    }),
  });

export const { useGetAllTicketsQuery, useGetSupportStaffTicketsQuery } =
  ticketsApi;
